'use client'

import React, { ReactElement, ReactNode, useContext, useEffect } from 'react'
import { OpenCloseContext } from '@/components/hotel/OpenCloseContext'
import classNames from 'classnames'

/**
 * This component ads a div that holds the class 'open' when the context is open. It should be used to together with
 * the 'open:' custom prefix.
 * @param props
 * @constructor
 */
export function OpenCloseWrapper(props: {
  children: ReactNode,
  className?: string,
  autoOpenWhenParameterHasValue?:  string
}): ReactElement {
  const { open, setOpen } = useContext(OpenCloseContext)!

  function programSelectedViaSearchParams(): boolean {
    if (!props.autoOpenWhenParameterHasValue) {
      return false
    }

    const selectedProgramId = new URLSearchParams(window?.location.search).get('p')
    return props.autoOpenWhenParameterHasValue === selectedProgramId
  }

  useEffect(() => {
    setOpen(programSelectedViaSearchParams())
  }, [])

  return <div className={classNames(props.className, { 'open': open })}>{props.children}</div>
}

